import { Box } from '@mui/joy';
import { useNavigate } from 'react-router-dom';

export default function Logo({ width = 150, height = 50, clickable = true }) {
    const navigate = useNavigate();

    const handleClick = () => {
        if (clickable) {
            navigate('/dashboard');
        }
    };

    return (
        <Box
            onClick={handleClick}
            sx={{
                cursor: clickable ? 'pointer' : 'default',
                display: 'flex',
                alignItems: 'center'
            }}
        >
            <img
                src="../logo-vector.svg"
                alt="Vector India Logo"
                width={width}
                height={height}
                loading="eager"
            />
        </Box>
    );
} 